import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? "border-border bg-background/85 backdrop-blur-md shadow-soft"
          : "border-transparent bg-background/60 backdrop-blur-sm"
      }`}
      data-testid="main-navbar"
    >
      <div className="container flex h-20 items-center justify-between">
        <Link to="/" data-testid="nav-home-logo">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${
                  isActive ? "text-secondary" : "text-foreground/70 hover:text-primary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/private-file"
            data-testid="nav-private-file"
            className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-white px-4 py-2 text-sm font-semibold text-primary transition-all hover:border-secondary hover:text-secondary"
          >
            <Lock className="h-4 w-4" /> Private File
          </Link>
          <Link to="/contact" className="btn-primary !px-6 !py-2.5" data-testid="nav-cta">
            Free Consultation
          </Link>
        </nav>

        <button
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-background/95 backdrop-blur md:hidden" data-testid="mobile-menu">
          <div className="container flex flex-col gap-1 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-semibold text-foreground/80 hover:bg-muted"
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/private-file"
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 rounded-lg px-3 py-3 text-sm font-semibold text-primary"
            >
              <Lock className="h-4 w-4" /> Private File
            </Link>
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary mt-2">
              Free Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
